import { render } from "./PlaceImageOnImage.vue?vue&type=template&id=8d32ba66&scoped=true"
import script from "./PlaceImageOnImage.vue?vue&type=script&lang=ts"
export * from "./PlaceImageOnImage.vue?vue&type=script&lang=ts"

import "./PlaceImageOnImage.vue?vue&type=style&index=0&id=8d32ba66&lang=less&scoped=true"
import "./PlaceImageOnImage.vue?vue&type=style&index=1&id=8d32ba66&lang=less"
script.render = render
script.__scopeId = "data-v-8d32ba66"

export default script